module.exports = __webpack_public_path__ + "assets/kids/img/nina-logo.5b848f00.jpg";